export var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["SPANISH"] = "es";
    LanguageEnum["ENGLISH"] = "en";
    LanguageEnum["PORTUGUESE"] = "br";
})(LanguageEnum || (LanguageEnum = {}));
